// extracted by mini-css-extract-plugin
module.exports = {"shield":"BookStatusShield__shield","text":"BookStatusShield__text","icon":"BookStatusShield__icon"};